import { NgModule } from '@angular/core';
import { RouterModule, Routes, ExtraOptions,UrlMatchResult } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./home-page/home-page.module').then((m) => m.HomePageModule),
  },
  {
    path: 'core-hr',
    loadChildren: () =>
      import('./core-hr-product-page/core-hr-product-page.module').then(
        (m) => m.CoreHrProductPageModule
      ),
  },
  {
    path: 'employee-management',
    loadChildren: () =>
      import('./employee-management/employee-management.module').then(
        (m) => m.EmployeeManagementModule
      ),
  },
  {
    path: 'attendance-management',
    loadChildren: () =>
      import('./time-and-attendance/time-and-attendance.module').then(
        (m) => m.TimeAndAttendanceModule
      ),
  },
  {
    path: 'hr-glossary',
    loadChildren: () =>
      import('./hr-glossary/hr-glossary.module').then(
        (m) => m.HrGlossaryModule
      ),
  },

  {
    path: 'payroll-management',
    loadChildren: () =>
      import('./payroll-management/payroll-management.module').then(
        (m) => m.PayrollManagementModule
      ),
  },
  {
    path: 'integrations',
    loadChildren: () =>
      import('./integrations/integrations.module').then(
        (m) => m.IntegrationsModule
      ),
  },
  // {
  //   path: 'resources',
  //   loadChildren: () =>
  //     import('./resources/resources.module').then((m) => m.ResourcesModule),
  // },
  {
    path: 'blog',
    loadChildren: () => import('./blog/blog.module').then((m) => m.BlogModule),
  },
  // {
  //   path: 'client-stories',
  //   loadChildren: () => import('./blog/blog.module').then((m) => m.BlogModule),
  // },
  {
    path: 'use-cases',
    loadChildren: () =>
      import('./usecases/usecases.module').then((m) => m.UsecasesModule),
  },
  {
    path: 'leave-management',
    loadChildren: () =>
      import('./leave-management/leave-management.module').then(
        (m) => m.LeaveManagementModule
      ),
  },
  {
    path: 'people-analytics',
    loadChildren: () =>
      import('./people-analytics/people-analytics.module').then(
        (m) => m.PeopleAnalyticsModule
      ),
  },

  {
    path: 'resources/hr-templates',
    loadChildren: () =>
      import('./hr-templates/hr-templates-routing.module').then(
        (m) => m.HrTemplatesRoutingModule
      )
  },
  // {
  //   path: 'client-stories-page',
  //   loadChildren: () =>
  //     import('./client-stories-pages/client-stories-pages.module').then(
  //       (m) => m.ClientStoriesPagesModule
  //     ),
  // },
  { path: 'pricing', loadChildren: () => import('./pricing-page/pricing-page.module').then(m => m.PricingPageModule) },
  { path: 'contact-us', loadChildren: () => import('./contact-us/contact-us.module').then(m => m.ContactUsModule) },
  // { path: 'product-demo', loadChildren: () => import('./product-demo/product-demo.module').then(m => m.ProductDemoModule) }, //FOR FUTURE USE
  { path: 'demo', loadChildren: () => import('./demo/demo.module').then(m => m.DemoModule) },
  // { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'authentication', loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule) },

  { path: 'about-us', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule) },
  { path: 'privacy-policy', loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
  { path: 'faq', loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule) },
  // { path: 'resources-detail', loadChildren: () => import('./resources-detail/resources-detail.module').then(m => m.ResourcesDetailModule) },
  { path: 'newsroom', loadChildren: () => import('./news-room/news-room.module').then(m => m.NewsRoomModule) },
  { path: 'employee-self-service', loadChildren: () => import('./ess-page/ess-page.module').then(m => m.EssPageModule) },
  // { path: 'client-stories-template', loadChildren: () => import('./client-stories-template/client-stories-template.module').then(m => m.ClientStoriesTemplateModule) },
  { path: 'hr-glossary/annual-leave', loadChildren: () => import('./annual-leave-page/annual-leave-page.module').then(m => m.AnnualLeavePageModule) },
  // { path: 'accrual-leave-detail', loadChildren: () => import('./accrual-leave/accrual-leave.module').then(m => m.AccrualLeaveModule) },
  { path: 'legal', loadChildren: () => import('./legal/legal.module').then(m => m.LegalModule) },
  { path: 'attendance-managements', loadChildren: () => import('./hr-glossary-detail/hr-glossary-detail.module').then(m => m.HrGlossaryDetailModule) },
  { path: 'careers', loadChildren: () => import('./career-page/career-page.module').then(m => m.CareerPageModule) },
  { path: 'ai-information', loadChildren: () => import('./ai-information/ai-information.module').then(m => m.AiInformationModule) },
  { path: 'hr-glossary/notice-period', loadChildren: () => import('./notice-period/notice-period.module').then(m => m.NoticePeriodModule) },
  { path: 'hr-glossary/paternity-leave', loadChildren: () => import('./parental-leave/parental-leave.module').then(m => m.ParentalLeaveModule) },
  { path: 'hr-glossary/payroll-cycle', loadChildren: () => import('./payroll-cycle/payroll-cycle.module').then(m => m.PayrollCycleModule) },
  { path: 'hr-glossary/salary-review', loadChildren: () => import('./salary-review/salary-review.module').then(m => m.SalaryReviewModule) },
  { path: 'hr-glossary/working-hours', loadChildren: () => import('./working-hours/working-hours.module').then(m => m.WorkingHoursModule) },
  { path: 'hr-glossary/employee-directory', loadChildren: () => import('./employee-directory/employee-directory.module').then(m => m.EmployeeDirectoryModule) },
  { path: 'hr-glossary/employee-self-service', loadChildren: () => import('./employee-self-service/employee-self-service.module').then(m => m.EmployeeSelfServiceModule) },
  { path: 'hr-glossary/accrued-leave', loadChildren: () => import('./accrual-leave/accrual-leave.module').then(m => m.AccrualLeaveModule) },
  { path: 'hr-glossary/time-in-lieu', loadChildren: () => import('./time-in-lieu/time-in-lieu.module').then(m => m.TimeInLieuModule) },
  { path: 'hr-glossary/headcount', loadChildren: () => import('./head-count/head-count.module').then(m => m.HeadCountModule) },
  { path: 'hr-glossary/hrms', loadChildren: () => import('./hrms/hrms.module').then(m => m.HrmsModule) },
  { path: 'hr-glossary/hr-software', loadChildren: () => import('./hr-software/hr-software.module').then(m => m.HrSoftwareModule) },
  { path: 'hr-glossary/biometric-systems', loadChildren: () => import('./biometric-systems/biometric-systems.module').then(m => m.BiometricSystemsModule) },
  { path: 'hr-glossary/core-hr', loadChildren: () => import('./core-hr-glossary-page/core-hr-glossary-page.module').then(m => m.CoreHrGlossaryPageModule) },
  { path: 'copyright', loadChildren: () => import('./copyright/copyright.module').then(m => m.CopyrightModule) },
  { path: 'hr-glossary/payroll-software', loadChildren: () => import('./payroll-software/payroll-software.module').then(m => m.PayrollSoftwareModule) },
  { path: 'hr-glossary/employee-engagement', loadChildren: () => import('./employee-engagement-page/employee-engagement-page.module').then(m => m.EmployeeEngagementPageModule) },
  { path: 'hr-glossary/payroll-management', loadChildren: () => import('./payroll-management-glossary-page/payroll-management-glossary-page.module').then(m => m.PayrollManagementGlossaryPageModule) },
  { path: 'hr-glossary/hr-policy', loadChildren: () => import('./hr-policy-glossary-page/hr-policy-glossary-page.module').then(m => m.HrPolicyGlossaryPageModule) },
  { path: 'hr-glossary/grievance', loadChildren: () => import('./grievance/grievance.module').then(m => m.GrievanceModule) },
  { path: 'hr-glossary/no-objection-certificate', loadChildren: () => import('./noc-page/noc-page.module').then(m => m.NOCPageModule) },
  { path: 'hr-glossary/cloud-hr-system', loadChildren: () => import('./cloud-hr-system/cloud-hr-system.module').then(m => m.CloudHrSystemModule) },
  { path: 'gratuity-calculator', loadChildren: () => import('./gratuity-calculator-page/gratuity-calculator-page.module').then(m => m.GratuityCalculatorPageModule) },
  { path: 'partner-program', loadChildren: () => import('./partner-program/partner-program.module').then(m => m.PartnerProgramModule) },
  { path: 'hr-glossary/basic-salary', loadChildren: () => import('./basic-salary-page/basic-salary-page.module').then(m => m.BasicSalaryPageModule) },
  { path: 'hr-glossary/end-of-service', loadChildren: () => import('./end-of-serivce-page/end-of-serivce-page.module').then(m => m.EndOfSerivcePageModule) },
  { path: 'hr-glossary/emiratization', loadChildren: () => import('./emiratization-page/emiratization-page.module').then(m => m.EmiratizationPageModule) },
  { path: 'hr-glossary/public-holidays', loadChildren: () => import('./public-holidays-page/public-holidays-page.module').then(m => m.PublicHolidaysPageModule) },
  { path: 'HR-Software', loadChildren: () => import('./hr-software-page/hr-software-page.module').then(m => m.HRSoftwarePageModule) },
  { path: 'security', loadChildren: () => import('./security/security.module').then(m => m.SecurityModule) },
  { path: 'hr-software-uae', loadChildren: () => import('./hr-landing-page/hr-landing-page.module').then(m => m.HrLandingPageModule) },
  { path: 'hr-glossary/employee-onboarding', loadChildren: () => import('./onboarding-page/onboarding-page.module').then(m => m.OnboardingPageModule) },
  { path: 'hr-glossary/employee-offboarding', loadChildren: () => import('./offboarding-page/offboarding-page.module').then(m => m.OffboardingPageModule) },
  { path: 'hr-glossary/leave-encashment', loadChildren: () => import('./leave-encashment-page/leave-encashment-page.module').then(m => m.LeaveEncashmentPageModule) },
  { path: 'hr-glossary/sick-leave', loadChildren: () => import('./sick-leave-page/sick-leave-page.module').then(m => m.SickLeavePageModule) },
  { path: 'hr-glossary/compassionate-Leave', loadChildren: () => import('./compassionate-leave-page/compassionate-leave-page.module').then(m => m.CompassionateLeavePageModule) },
  { path: 'product-tour', loadChildren: () => import('./product-tours/product-tours.module').then(m => m.ProductToursModule) },
  { path: 'hr-glossary/maternity-leave', loadChildren: () => import('./maternity-leave-detail/maternity-leave-detail.module').then(m => m.MaternityLeaveDetailModule) },
  { path: '404', loadChildren: () => import('./default-page/default-page.module').then(m => m.DefaultPageModule) },



  // { path: 'help-center', loadChildren: () => import('./help-center/help-center.module').then(m => m.HelpCenterModule) }, FUTURE USE
  // { path: 'help-center-list/:id', loadChildren: () => import('./help-center-list/help-center-list.module').then(m => m.HelpCenterListModule) }, FUTURE USE

  // { path: 'help-center/:slug', loadChildren: () => import('./help-center-details/help-center-details.module').then(m => m.HelpCenterDetailsModule) }, FUTURE USE



  {
    path: 'blog/:slug',
    loadChildren: () =>
      import('./blog-detail/blog-detail.module').then(
        m => m.BlogDetailModule
      ),
  },
  {
    matcher: (segments, group, route): UrlMatchResult | null => {
      // Check the raw URL from the browser
      if (typeof window !== 'undefined') {
        const pathname = window.location.pathname;
        const href = window.location.href;

        // Check if pathname or full URL contains %23 (encoded #)
        if (pathname.includes('%23') || href.includes('%23')) {
          // Match all segments to consume the entire path
          return { consumed: segments };
        }
      }

      // Also check route segments (in case URL was already partially decoded)
      const hasEncodedHash = segments.some(segment => segment.path.includes('%23'));
      if (hasEncodedHash) {
        return { consumed: segments };
      }

      return null;
    },
    loadChildren: () =>
      import('./url-redirect/url-redirect.module').then(
        m => m.UrlRedirectModule
      ),
  },
  { path: 'demo-popup', loadChildren: () => import('./components/demo-popup/demo-popup.module').then(m => m.DemoPopupModule) },
  { path: '**', redirectTo: '404' }



];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled',
  initialNavigation: 'enabledBlocking',
  // scrollOffset: [0, 64] // optional, if you have a fixed header
};

@NgModule({
  imports: [
    RouterModule.forRoot(routes, routerOptions),

  ],

  exports: [RouterModule],
})
export class AppRoutingModule { }

// Demo changes
